/**
 * List of all locales across all apps
 */
export const sharedLocaleList = [
  'en_com',
  'de_de',
  'de_at',
  'en_uk',
  'nl_be',
  'fr_be',
  'fr_fr',
  'nl_nl',
  'es_es',
  'ja_jp',
  'en_us',
  'zh_cn',
  'fr_ch',
  'de_ch',
] as const;

export type SharedLocale = (typeof sharedLocaleList)[number];

export type SharedLanguage = 'en' | 'es' | 'nl' | 'de' | 'fr' | 'ja' | 'zh';

export type SharedLocaleHreflang =
  | 'en'
  | 'de-DE'
  | 'de-AT'
  | 'en-GB'
  | 'nl-BE'
  | 'fr-BE'
  | 'fr-FR'
  | 'nl-NL'
  | 'es-ES'
  | 'ja-JP'
  | 'en-US'
  | 'zh-CN'
  | 'fr-CH'
  | 'de-CH';
